import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';


const firebaseConfig = {
  apiKey: "AIzaSyBBjq4byyfZd9qpEoHhhVUxWoxN1_1-7bs",
  authDomain: "whitelabelbuddy.firebaseapp.com",
  projectId: "whitelabelbuddy",
  storageBucket: "whitelabelbuddy.firebasestorage.app",
  messagingSenderId: "132565323538",
  appId: "1:132565323538:web:1799d54ca4458829ee6dcb"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

/**
 * Who Firebase's own account emails (password reset, email verification) come FROM.
 * Firebase Auth sends these itself — NOT through the firestore-send-email extension —
 * using noreply@<authDomain> unless a custom SMTP sender is configured in the console.
 * Surfaced in the UI so a bidder knows what to search for in their spam folder.
 */
export const AUTH_EMAIL_SENDER = `noreply@${firebaseConfig.authDomain}`;

// Explicit: localStorage persistence so auth survives page navigation,
// browser restart, and the bid-from-tile -> page-nav flow tested for Sunday.
// (browserLocalPersistence is Firebase's default; we lock it in to remove ambiguity.)
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.warn('Firebase Auth persistence setup failed:', err);
});

export const db = getFirestore(app);
export const storage = getStorage(app);
// Callable Cloud Functions (Track B Phase 1b card-auth registration lives here).
// Default region us-central1, matching the deployed functions.
export const functions = getFunctions(app);
export default app;
